import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import './Contacto.css';

function Contacto() {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    tipoConsulta: 'Consultoría en Plantaciones',
    pais: '',
    mensaje: '',
  });
  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Build pre-filled WhatsApp message with form details
    const text = `*Nueva Consulta desde Sol de Vainilla*\n\n` +
      `*Nombre:* ${formData.nombre}\n` +
      `*Email:* ${formData.email}\n` +
      `*Teléfono:* ${formData.telefono}\n` +
      `*Tipo de Consulta:* ${formData.tipoConsulta}\n` +
      `*País / Ubicación:* ${formData.pais || 'No especificado'}\n` +
      `*Mensaje:* ${formData.mensaje}`;

    const waUrl = `https://wa.me/50686191589?text=${encodeURIComponent(text)}`;
    window.open(waUrl, '_blank', 'noopener,noreferrer');
    setFormSubmitted(true);
  };

  const directWhatsappUrl = 'https://wa.me/50686191589?text=' + encodeURIComponent('Hola Gabriela, me gustaría información sobre sus servicios de consultoría y productos de Sol de Vainilla.');

  return (
    <div className="contacto-page">
      <Helmet>
        <title>Contacto y Consultoría | Sol de Vainilla</title>
        <meta
          name="description"
          content="Contáctenos para consultoría técnica en plantaciones de vainilla, evaluación de inversiones o pedidos de vainilla 100% costarricense. Atención en Costa Rica, México, Guatemala, Honduras, Nicaragua y virtual."
        />
      </Helmet>

      {/* Header */}
      <section
        className="contacto-hero"
        style={{
          backgroundImage:
            "radial-gradient(circle at center, rgba(14, 25, 12, 0.65) 0%, rgba(10, 18, 9, 0.9) 100%), url('/field2.jpeg')",
        }}
      >
        <div className="container">
          <span className="contacto-badge">Atención Personalizada</span>
          <h1>Contáctenos</h1>
          <p>
            ¿Planea iniciar una plantación, resolver desafíos o adquirir vainilla 100% pura?
            Estamos a su disposición para asesorarle en cada paso.
          </p>
        </div>
      </section>

      {/* Main Grid */}
      <section className="contacto-main-section">
        <div className="container">
          <div className="contacto-grid">
            {/* Left Column: Direct Info, Coverage, and Images */}
            <div className="contacto-info-column">
              {/* Direct Channels Card */}
              <div className="info-card">
                <h3>Canales de Atención Directa</h3>
                <p className="info-card-intro">
                  Comuníquese directamente con nuestra especialista en consultoría de vainilla para recibir asesoría técnica y respuestas rápidas a sus consultas.:
                </p>

                <div className="channel-item">
                  <div className="channel-icon whatsapp-color">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
                    </svg>
                  </div>
                  <div>
                    <span className="channel-label">WhatsApp:</span>
                    <a href={directWhatsappUrl} target="_blank" rel="noopener noreferrer" className="channel-link">
                      +506 8619 1589
                    </a>
                  </div>
                </div>

                <div className="channel-item">
                  <div className="channel-icon phone-color">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                    </svg>
                  </div>
                  <div>
                    <span className="channel-label">Teléfono:</span>
                    <a href="tel:+50686191589" className="channel-link">
                      +506 8619 1589
                    </a>
                  </div>
                </div>

                <div className="channel-item">
                  <div className="channel-icon email-color">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect width="20" height="16" x="2" y="4" rx="2" />
                      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                    </svg>
                  </div>
                  <div>
                    <span className="channel-label">Correo Electrónico:</span>
                    <a href="mailto:gaby@soldevainilla.com" className="channel-link">
                      gaby@soldevainilla.com
                    </a>
                  </div>
                </div>

                <div className="contacto-whatsapp-cta">
                  <a
                    href={directWhatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="whatsapp-primary-button"
                  >
                    <span>Escribir ahora por WhatsApp</span>
                  </a>
                </div>
              </div>

              {/* Geographic Coverage Card */}
              <div className="info-card coverage-card">
                <h3>Cobertura de Consultoría</h3>
                <div className="coverage-flags">
                  <span className="coverage-tag">🇨🇷 Costa Rica</span>
                  <span className="coverage-tag">🇲🇽 México</span>
                  <span className="coverage-tag">🇬🇹 Guatemala</span>
                  <span className="coverage-tag">🇭🇳 Honduras</span>
                  <span className="coverage-tag">🇳🇮 Nicaragua</span>
                  <span className="coverage-tag">Otro País</span>
                  <span className="coverage-tag">🌐 Modalidad Virtual</span>
                </div>
                <p>
                  Ofrecemos visitas técnicas y diagnósticos de campo en plantaciones de Mesoamérica, así como consultorías estructuradas por videollamada para productores internacionales.
                </p>
              </div>

              {/* Visual Field & Lab Showcase */}
              <div className="contacto-gallery">
                <div className="gallery-photo-item">
                  <img src="/field2.jpeg" alt="Asesoría técnica en plantación de vainilla" />
                  <span>Trabajo en campo</span>
                </div>
                <div className="gallery-photo-item">
                  <img src="/lab1.jpeg" alt="Investigación y análisis biotecnológico" />
                  <span>Investigación científica y sanidad</span>
                </div>
              </div>
            </div>

            {/* Right Column: Interactive Consultation & Order Form */}
            <div className="contacto-form-column">
              <div className="form-wrapper">
                <h3>Solicitud de Consultoría o Información</h3>
                <p className="form-intro">
                  Complete los detalles de su proyecto y nos pondremos en contacto a la brevedad con una propuesta técnica.
                </p>

                {formSubmitted && (
                  <div className="form-success-banner">
                    <strong>¡Gracias por su mensaje!</strong>
                    <p>Su consulta se ha preparado para envío inmediato. También puede contactarnos directamente al +506 8619 1589.</p>
                  </div>
                )}

                <form onSubmit={handleSubmit} className="contacto-form">
                  <div className="form-group">
                    <label htmlFor="nombre">Nombre Completo *</label>
                    <input
                      type="text"
                      id="nombre"
                      name="nombre"
                      required
                      placeholder="Ej. Carlos Méndez"
                      value={formData.nombre}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="email">Correo Electrónico *</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        required
                        placeholder="carlos@ejemplo.com"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="telefono">Teléfono / WhatsApp *</label>
                      <input
                        type="tel"
                        id="telefono"
                        name="telefono"
                        required
                        placeholder="+506 8888 8888"
                        value={formData.telefono}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="tipoConsulta">Tipo de Consulta *</label>
                      <select
                        id="tipoConsulta"
                        name="tipoConsulta"
                        value={formData.tipoConsulta}
                        onChange={handleChange}
                      >
                        <option value="Consultoría Integral en Plantaciones">Consultoría en Plantaciones</option>
                        <option value="Evaluación de Inversiones y Factibilidad">Evaluación de Inversiones / ROI</option>
                        <option value="Manejo contra Plagas y Enfermedades (MIPE)">Planes contra Plagas y Enfermedades</option>
                        <option value="Buenas Prácticas Agrícolas y Capacitación">Buenas Prácticas Agrícolas (BPA)</option>
                        <option value="Compra de Productos (Vainas, Extracto, Aceite)">Compra de Productos Gourmet</option>
                        <option value="Otra Consulta">Otra Consulta</option>
                      </select>
                    </div>

                    <div className="form-group">
                      <label htmlFor="pais">País / Región de la Finca</label>
                      <input
                        type="text"
                        id="pais"
                        name="pais"
                        placeholder="Ej. Costa Rica, México, etc."
                        value={formData.pais}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="mensaje">Detalles de su Consulta o Proyecto *</label>
                    <textarea
                      id="mensaje"
                      name="mensaje"
                      required
                      rows="5"
                      placeholder="Describa el tamaño de su terreno, etapa de la plantación o las necesidades específicas de su consulta..."
                      value={formData.mensaje}
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  <button type="submit" className="form-submit-button">
                    Enviar Consulta Técnica
                  </button>
                  <span className="form-privacy-note">
                    🔒 Sus datos serán tratados con total confidencialidad para fines exclusivos de su asesoría.
                  </span>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contacto;